// dependencies
import PropTypes from "prop-types";
import React from "react";

// utils
import Serialize from "../../../react/utils/SerializeObject";

// styles
import css from "./GoogleLoginButton.module.scss";

type GoogleLoginButtonProps = {
	queryParameters: Record<string, string>;
};

const GoogleLoginButton = ({ queryParameters = {} }: GoogleLoginButtonProps) => {
	const query = Serialize(queryParameters);

	return (
		<a href={`/login/google-oauth/?${query}`} className={`${css.main}`} aria-label="Sign in with Google">
			<div className={css.iconWrapper}>
				<img alt="" src="/static/img/Integrations/google-logo.png" />
			</div>
			<div className={css.label}>Sign in with Google</div>
		</a>
	);
};

export default GoogleLoginButton;
